import type { paths } from 'apis/cloud-enterprise-policy-api';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';

import { CONFIG } from 'src/config';

import type { ApiErrors } from '../apiErrorHelpers.types';
import { addAuthHeader } from './middleware/addAuthHeader';
import { throwOnErrorResponse } from './middleware/throwOnErrorResponse';

const apiClient = createFetchClient<paths>({
  baseUrl: CONFIG.CloudEnterpriseApiUrl,
});

apiClient.use(addAuthHeader);

const cloudEnterprisePolicyApi = createClient(apiClient);

export type CloudEnterprisePolicyApiError = ApiErrors<paths>;

// === Separate client instance for react query with error handling middleware ===

const cloudEnterprisePolicyApiClient = createFetchClient<paths>({
  baseUrl: CONFIG.CloudEnterpriseApiUrl,
});

cloudEnterprisePolicyApiClient.use(addAuthHeader, throwOnErrorResponse);

export { cloudEnterprisePolicyApi, cloudEnterprisePolicyApiClient };
